import * as React from 'react';
import { IconProps, SIZE_MAP } from '../types';
import { cn } from '../../../utils/cn';

const CheckSolidIcon = ({ size = 'lg', className, ...props }: IconProps) => {
  const px = SIZE_MAP[size];

  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-primary', className)}
      {...props}
    >
      <path
        d="M19.0956 5.63672C19.5723 5.13739 20.3638 5.11904 20.8632 5.5957C21.3625 6.07238 21.3809 6.86392 20.9042 7.36328L10.4042 18.3633C10.1718 18.6067 9.85103 18.7461 9.51455 18.75C9.17802 18.7539 8.8541 18.6218 8.61612 18.3838L3.11612 12.8838C2.62796 12.3956 2.62796 11.6044 3.11612 11.1162C3.57378 10.6585 4.298 10.6298 4.78897 11.0303L4.88369 11.1162L9.47842 15.7109L19.0956 5.63672Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CheckSolidIcon;
